if (process.client) {
  if (typeof window.wcs === 'undefined') {
    window.wcs = {
      inflow: () => {}
    }
  }
  if (typeof window.wcs_do === 'undefined') {
    window.wcs_do = () => {}
  }
}

/**
 *
 * @param {string} host 접속한 호스트
 * @param {object} nasa
 * @param {string} nasa.cnv wcs.cnv('전환 유형', '결제 금액') 의 결과값이 저장될 필드
 *
 */

export const useNaverAds = () => {
  const config = useRuntimeConfig()
  const sendWCSLog = (host:any, nasa:any) => {
    if (config.public.env !== 'prod') { return } // 프로덕션 환경에서만 실행
    if (process.server) { return }
    if (!window.wcs_add) { window.wcs_add = {} } // 설정하지 않으면 'unknown'으로 설정된다
    window.wcs_add.wa = useRuntimeConfig().public.naverAdsKey // 네이버 공통키
    if (!nasa) { nasa = {} }
    if (window.wcs) {
      window.wcs.inflow(host)
      window.wcs_do(nasa)
    }
  }

  return {
    sendWCSLog
  }
}
